import { render } from "./SideMessage.vue?vue&type=template&id=637f148a&scoped=true"
import script from "./SideMessage.vue?vue&type=script&lang=js"
export * from "./SideMessage.vue?vue&type=script&lang=js"

import "./SideMessage.vue?vue&type=style&index=0&id=637f148a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637f148a"]])

export default __exports__